import { requestDevApi } from './client';
export async function create(options = {}) {
    const body = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (options.name !== undefined ? { name: options.name } : {})), (options.prompt !== undefined ? { prompt: options.prompt } : {})), (options.idempotencyKey !== undefined ? { idempotencyKey: options.idempotencyKey } : {})), (options.intent !== undefined ? { intent: options.intent } : {})), (options.oapp === true ? { oapp: true } : {}));
    const app = await requestDevApi('/apps/new', {
        method: 'POST',
        body,
    });
    return Object.assign(Object.assign(Object.assign(Object.assign({ appId: app.appId }, (typeof app.slug === 'string' && app.slug ? { slug: app.slug } : {})), { url: app.url }), (typeof app.prompt === 'string' && app.prompt ? { prompt: app.prompt } : {})), (typeof app.handoff === 'string' && app.handoff ? { handoff: app.handoff } : {}));
}
/**
 * F-1200: build the create-flow redirect the owner is sent to after `create()`, with the
 * prompt and handoff carried in the URL FRAGMENT (never the query - fragments never reach
 * servers, logs, or Referer). Encoding is byte-exact so the widget's `URLSearchParams`
 * parse + `.trim()` reproduces the SAME prompt string dev-api hashed into the handoff;
 * getting this wrong would make the widget reject a genuine token and degrade to prefill.
 * First-party product callers should use this instead of hand-building the URL.
 *
 * Returns `${url}#bounded_prompt=<prompt>` with no `&bounded_handoff=` when the server
 * minted no handoff (HANDOFF_SECRET unset) - the widget then prefills without auto-running.
 */
export function buildCreateRedirectUrl(app) {
    const base = app.url;
    const prompt = typeof app.prompt === 'string' ? app.prompt.trim() : '';
    if (!prompt)
        return base;
    const params = `bounded_prompt=${encodeURIComponent(prompt)}`
        + (app.handoff ? `&bounded_handoff=${encodeURIComponent(app.handoff)}` : '');
    return `${base}#${params}`;
}
export async function list() {
    // Keep this legacy-compatible action shape for existing first-party callers.
    const response = await requestDevApi('/', {
        method: 'POST',
        body: { action: 'listApps' },
    });
    const rows = Array.isArray(response.apps) ? response.apps : [];
    return rows
        .map((value) => {
        var _a, _b, _c, _d;
        const row = value && typeof value === 'object'
            ? value
            : {};
        const appId = String((_c = (_b = (_a = row._id) !== null && _a !== void 0 ? _a : row.id) !== null && _b !== void 0 ? _b : row.appId) !== null && _c !== void 0 ? _c : '');
        if (!/^[a-f0-9]{24}$/i.test(appId))
            return null;
        const name = String((_d = row.name) !== null && _d !== void 0 ? _d : '').trim() || '(unnamed app)';
        const slug = typeof row.slug === 'string' && row.slug ? row.slug : undefined;
        const url = typeof row.url === 'string' && row.url.trim() ? row.url.trim() : undefined;
        const buildStatus = row.buildStatus === 'building' || row.buildStatus === 'build_failed'
            ? row.buildStatus
            : undefined;
        return Object.assign(Object.assign(Object.assign({ appId,
            name }, (slug ? { slug } : {})), (url ? { url } : {})), (buildStatus ? { buildStatus } : {}));
    })
        .filter((app) => app !== null);
}
/**
 * Registered first-party product surfaces only -
 * dev-api CORS blocks calls from generated-app origins. Server-side callers unaffected.
 */
export const apps = { create, list, buildCreateRedirectUrl };
